import React, { useEffect, useState } from "react";
import Box from '@material-ui/core/Box';

import * as Sentry from "@sentry/react";

export default function LoadingAnimation() {

  const [startTime] = useState(new Date());
  const [timeLeft, setTimeLeft] = useState(0);
  const [sentryFlag, setSentryFlag] = useState(false);

  // There is a memory leak error here that should be addressed later.
  useEffect(() => {
      setTimeout(() => {
        setTimeLeft(new Date() - startTime);
         //console.log(timeLeft)   // 10000 is 10 seconds
        if(timeLeft > 10000 && sentryFlag === false){
            Sentry.captureMessage("Loading for more than 10 Seconds");
            setSentryFlag(true);
            console.log('GTM Container has loaded for more than 10 seconds')
        }
      }, 1000);

  });

  let width = (Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0) > 500)?"20vw":"40vw";

  return (
     <Box display="flex" height="80vh" bgcolor="#fafafa">
       <Box m="auto" width={width}>

          <img src="/loading-animation.gif" width="100%" alt="Loading"/>
      </Box>
    </Box>
   );

}
